import React, { useEffect, useState, useCallback } from "react";
import { authFetch, C } from "./App";

export function LogsView({ token }) {
  const [files, setFiles] = useState([]);
  const [selected, setSelected] = useState(null);
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [linesLoading, setLinesLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    authFetch("/admin/logs", token)
      .then((d) => {
        setFiles(d.files || []);
        if (d.files?.length) setSelected(d.files[0].name);
      })
      .catch((e) => setErr(e.message))
      .finally(() => setLoading(false));
  }, [token]);

  const loadLines = useCallback(() => {
    if (!selected) return;
    setLinesLoading(true);
    authFetch(`/admin/logs/${selected}?lines=300`, token)
      .then((d) => setLines(d.lines || []))
      .catch((e) => setErr(e.message))
      .finally(() => setLinesLoading(false));
  }, [token, selected]);

  useEffect(() => { loadLines(); }, [loadLines]);

  function isErrorLine(line) {
    return /error|fail|exception|❌/i.test(line);
  }

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "#111", margin: "0 0 4px" }}>Error Logs</h1>
      <p style={{ fontSize: 13, color: C.gray, margin: "0 0 20px" }}>Server activity and error history</p>

      {err && <div style={{ color: C.danger, fontSize: 13, marginBottom: 14 }}>{err}</div>}

      {loading ? (
        <div style={{ color: C.gray, fontSize: 13 }}>Loading…</div>
      ) : files.length === 0 ? (
        <div style={{ color: C.gray, fontSize: 13, padding: 30, textAlign: "center", background: C.white, borderRadius: 12, border: `1px solid ${C.border}` }}>No log files found.</div>
      ) : (
        <>
          <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
            {files.map((f) => (
              <button
                key={f.name} onClick={() => setSelected(f.name)}
                style={{
                  padding: "7px 13px", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer",
                  border: selected === f.name ? `1px solid ${C.green}` : `1px solid ${C.border}`,
                  background: selected === f.name ? "#E8F5E9" : "#fff",
                  color: selected === f.name ? C.green : "#444",
                }}
              >
                {f.name} <span style={{ color: C.gray, fontWeight: 400 }}>({(f.size / 1024).toFixed(1)}KB)</span>
              </button>
            ))}
            <button onClick={loadLines} style={{ padding: "7px 13px", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer", border: `1px solid ${C.border}`, background: "#fff", marginLeft: "auto" }}>↻ Refresh</button>
          </div>

          <div style={{ background: "#0A1628", borderRadius: 10, padding: 16, maxHeight: 560, overflowY: "auto", fontFamily: "monospace", fontSize: 11.5 }}>
            {linesLoading ? (
              <div style={{ color: "rgba(255,255,255,0.5)" }}>Loading…</div>
            ) : lines.length === 0 ? (
              <div style={{ color: "rgba(255,255,255,0.4)" }}>This log is empty.</div>
            ) : (
              lines.map((line, i) => (
                <div key={i} style={{ color: isErrorLine(line) ? "#FF8A80" : "rgba(255,255,255,0.75)", whiteSpace: "pre-wrap", wordBreak: "break-all", padding: "2px 0", borderBottom: i < lines.length - 1 ? "1px solid rgba(255,255,255,0.04)" : "none" }}>
                  {line}
                </div>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
}
